import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from 'styled-components';
import { useMedia } from '@mlb/react-patterns/v4/utils/hooks/useMedia/useMedia';
import { ChipFeedDataContainer } from '../ChipFeed';
import PitchFxDataContainer from '../PitchFx/PitchFxDataContainer';
import GDBREAKPOINTS from '../themes/breakpoints';
import { liveViewsTypes } from '../themes/liveViewsTypes';
import { LayoutWrapper, PitchByPitchMiniHomeWrapper } from './LiveMiniHome.style';
import { ChipFeedWrapper, LiveWrapper } from './Live.style';
import GameContextDataContainer from '../GameContext/GameContextDataContainer';

const miniHomePitchFxConfig = {
    batterScaling: false,
    tiltShift: false,
    fixed_width: 1080,
    hoverData: false,
    fontSize: 100
};

const PitchFxBundle = ({ viewType, strikezoneOnly, useFullViewport }) => (
    <>
        <PitchByPitchMiniHomeWrapper $strikezoneOnly={strikezoneOnly} $useFullViewport={useFullViewport}>
            <PitchFxDataContainer viewType={viewType} pitchFxConfig={miniHomePitchFxConfig} />
        </PitchByPitchMiniHomeWrapper>
        <ChipFeedWrapper $type={viewType} $useFullViewport={useFullViewport}><ChipFeedDataContainer /></ChipFeedWrapper>
    </>
);
PitchFxBundle.propTypes = {
    viewType: PropTypes.string,
    strikezoneOnly: PropTypes.bool,
    useFullViewport: PropTypes.bool
};

const {
    XS_MAX,
    SM_MIN,
    SM_REG_MAX,
    SM_WIDE_MIN,
    SM_MAX
} = GDBREAKPOINTS;

const {
    SINGLE,
    SINGLENARROW,
    SINGLEWIDE
} = liveViewsTypes;

const liveWrapperTypeMap = {
    [SINGLENARROW]: LiveWrapper,
    [SINGLE]: LiveWrapper,
    [SINGLEWIDE]: LiveWrapper
};

export const LiveTeamSummaryProps = {
    displayRecords: true,
    hideTeamNames: false
};

const LiveMiniHome = ({ strikezoneOnly, useFullViewport, gameContextOnly }) => {
    const isSingleColumnNarrow = useMedia({ maxWidth: XS_MAX });
    const isSingleColumnRegular = useMedia({ minWidth: SM_MIN, maxWidth: SM_REG_MAX });
    const isSingleColumnWide = useMedia({ minWidth: SM_WIDE_MIN, maxWidth: SM_MAX });
    let viewType = SINGLE;

    if (isSingleColumnNarrow) {
        viewType = SINGLENARROW;
    } else if (isSingleColumnRegular) {
        viewType = SINGLE;
    } else if (isSingleColumnWide) {
        viewType = SINGLEWIDE;
    }

    const LiveWrapperClass = liveWrapperTypeMap?.[viewType] ?? liveWrapperTypeMap?.[SINGLE];
    const MainComponent = useMemo(() => {
        if (strikezoneOnly) {
            return (PitchFxBundle({ viewType, strikezoneOnly, useFullViewport: true }));
        } else if (gameContextOnly) {
            return (<GameContextDataContainer gameState='L' useFullViewport={false} />);
        } else {
            return (
                <>
                    {PitchFxBundle({ viewType, useFullViewport })}
                    <GameContextDataContainer gameState='L' useFullViewport={useFullViewport} />
                </>
            );
        }
    }, [strikezoneOnly, viewType, LiveTeamSummaryProps]);

    return (
        <LiveWrapperClass type={viewType}>
            <LayoutWrapper type={viewType} $useFullViewport={useFullViewport}>
                {MainComponent}
            </LayoutWrapper>
        </LiveWrapperClass>
    );
};

LiveMiniHome.propTypes = {
    strikezoneOnly: PropTypes.bool,
    gameContextOnly: PropTypes.bool,
    useFullViewport: PropTypes.bool
};

export default withTheme(LiveMiniHome);
